import './_controller.scss';
import LeftSidebar from "./left-sidebar/left-sidebar";
import Toolbar from "./toolbar/toolbar";
const Controller = () => {
    return <div id='controller-container' className='controller-container'>
        <LeftSidebar/>
        <Toolbar/>
    </div>
}

export default Controller;
